export default "/34887f8f847f5d202a469a9dd4881160882f8c6b/e0ab7379baf600f9962514af15119239.png";